module.exports = __webpack_public_path__ + "static/media/pl.6607e08c.svg";